import React from 'react';
import { motion } from 'framer-motion';
import { Zap, DollarSign, UserCheck, ThumbsUp } from 'lucide-react';
const features = [{
  title: 'Fast Dispatch',
  description: 'Same-day and next-day delivery. Order before 10 AM and get it today.',
  icon: Zap
}, {
  title: 'Bulk Pricing',
  description: 'Best pricing in the Tacoma area. No hidden fees, transparent quotes.',
  icon: DollarSign
}, {
  title: 'Owner-Operated',
  description: 'Deal directly with the people who care about your project.',
  icon: UserCheck
}, {
  title: 'Easy Ordering',
  description: 'Call, text, or use our instant quote tool. Simple as that.',
  icon: ThumbsUp
}];
export function WhyUs() {
  return <section className="py-16 bg-stone-100 dark:bg-[#2e2e2e] transition-colors duration-300 border-y border-stone-400 dark:border-[#3a3a3a]" id="why-us" data-id="element-1142">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1143">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-1144">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-stone-900 dark:text-white mb-2" data-id="element-1145">
            Why Choose 253Gravel.com
          </h2>
          <p className="text-stone-800 dark:text-stone-300 text-base font-sub" data-id="element-1146">
            Speed. Reliability. Simplicity.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1147">
          {features.map((feature, index) => <motion.div key={feature.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="flex flex-col items-center text-center px-2" data-id="element-1148">
              <div className="w-10 h-10 bg-brand-dim/10 dark:bg-brand-dim/20 rounded-xl flex items-center justify-center mb-4 border border-brand-dim/20 dark:border-brand-dim/30" data-id="element-1149">
                <feature.icon className="w-5 h-5 text-brand-dim" data-id="element-1150" />
              </div>
              <h3 className="font-heading text-sm font-bold text-stone-900 dark:text-white mb-1" data-id="element-1151">
                {feature.title}
              </h3>
              <p className="text-stone-600 dark:text-stone-400 text-xs leading-relaxed" data-id="element-1152">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}